export const SelectedDrawerState  = {
    SHOW_TRIAGE  : 'triage',
    SHOW_CLEARED_TRIAGE : 'cleared_triage',
    SHOW_SENT_EMAILS : 'sent_emails',
};

export const setSelectedDrawerState = (drawerState) =>  ({
    type: 'SET_SELECTED_DRAWER_STATE',
    drawerState
})